/** Proto `opExecLabels` — short Vietnamese Field status. */
export function mesOpStatusLabel(status: string): string {
  switch (status) {
    case "Pending":
      return "Chờ";
    case "InProgress":
      return "Đang chạy";
    case "Completed":
      return "Hoàn tất";
    case "Skipped":
      return "Bỏ qua";
    case "Blocked":
      return "Tạm giữ";
    case "Paused":
      return "Tạm dừng";
    case "Cancelled":
      return "Đã hủy";
    default:
      return status;
  }
}

/** Short action cue — pair with icon on FieldTaskCard. */
export function mesOpActionLabel(status: string): string {
  switch (status) {
    case "InProgress":
      return "Tiếp tục";
    case "Paused":
      return "Tiếp tục";
    case "Blocked":
      return "Xem lệnh giữ";
    case "Pending":
      return "Bắt đầu";
    default:
      return "Mở";
  }
}

/** Ghi chú lịch sử trạng thái (BE từng ghi tiếng Anh: start / complete…). */
export function mesOpHistoryNoteLabel(note: string | null | undefined): string | null {
  const raw = note?.trim();
  if (!raw) return null;

  const lower = raw.toLowerCase();
  if (lower === "start") return "Bắt đầu";
  if (lower === "resume") return "Tiếp tục";
  if (lower === "complete") return "Hoàn tất";
  if (lower === "complete+foreign") return "Hoàn tất · dị vật";
  if (lower === "op complete") return "Hoàn tất công đoạn";
  if (lower === "created") return "Tạo mới";
  if (lower === "spawn-from-plan") return "Sinh từ kế hoạch";
  if (lower === "hold released") return "Gỡ tạm giữ";
  if (lower.startsWith("hold released")) return "Gỡ tạm giữ — tiếp tục sau CCP";
  if (lower.startsWith("pause:")) return `Tạm dừng: ${raw.slice(raw.indexOf(":") + 1).trim()}`;
  if (lower.startsWith("cancel:")) return `Hủy: ${raw.slice(raw.indexOf(":") + 1).trim()}`;
  if (lower.startsWith("tạm dừng:")) return raw;
  if (lower.startsWith("hủy:")) return raw;

  return raw;
}

/** Trạng thái thông số CCP (InSpec / Warning / Breach). */
export function mesParamSpecStateLabel(state: string | null | undefined): string {
  switch ((state ?? "").trim()) {
    case "InSpec":
      return "Đạt";
    case "Warning":
      return "Sát giới hạn";
    case "Breach":
      return "Ngoài giới hạn";
    case "Pending":
      return "Chờ";
    default:
      return state?.trim() || "—";
  }
}

/** Tên hiển thị chỉ tiêu kỹ thuật (khớp MesOperationService.ParamLabel). */
export function mesParamCodeLabel(code: string | null | undefined): string {
  const key = (code ?? "").trim();
  if (!key) return "—";
  switch (key.toLowerCase()) {
    case "temp_c":
      return "Nhiệt độ nấu";
    case "brix":
      return "Brix";
    case "zone1_c":
      return "Nhiệt độ zone 1";
    case "zone2_c":
      return "Nhiệt độ zone 2";
    case "zone3_c":
      return "Nhiệt độ zone 3";
    case "zone4_c":
      return "Nhiệt độ zone 4";
    case "md_ok":
      return "Metal detector";
    case "cap_torque_nm":
      return "Momen siết nắp";
    default:
      return key;
  }
}
